<script>
    export let data;

    import {Button} from "carbon-components-svelte";
    import FolderDetailsReference20 from "carbon-icons-svelte/lib/FolderDetailsReference20";
    import EnumStatus from "../services/taskstatus";
    import {updateTask} from "../store";

    function updateTaskDo() {
        console.log("createProject: init");
        project = {
                name: newProjectName,
                status: 0,
            };


        data.setStatus(EnumStatus.ASAP);
        data = data;
        updateTask(data)
    }

    let taskid = data.id;
</script>

<Button kind="ghost" iconDescription="Convert To Project" on:click={updateTaskDo} icon={FolderDetailsReference20}
></Button
>

<!-- <style>
Button {
    text-align: center;
    padding: 0em;
    max-width: 240px;
    margin: 0 auto;
}
</style> -->